import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import * as Styled from './company-card-container.styles';

export const CompanyCardContainer = ({
  children = [],
  dataTestId = 'container-company-card',
}: {
  children?: React.JSX.Element[];
  dataTestId?: string;
}) => {
  const { isLoggedIn } = useLoginState();

  return (
    <Styled.Container data-testid={dataTestId}>
      {children.map((child, i) => (
        <Styled.Wrapper
          key={`companyCard-${i}`}
          className={isLoggedIn ? 'loggedInWrapper' : 'loggedOutWrapper'}
        >
          {child}
        </Styled.Wrapper>
      ))}
    </Styled.Container>
  );
};
